import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const JquerywebServices: React.FC<Props> = ({ title}) => {
  return (
    <section className="Development-Services section-py bg-grey">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10 gap-5 md:gap-5 lg:gap-10">
          <div className="xl:col-span-6 lg:col-span-6 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary mb-0 fw-400">
              Hire Dedicated jQuery Developers from Moweb to Ensure Result-Driven jQuery Web Development Solutions
              </p>
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="jQuery Web UI Development" />
            <KEYBlue text="jQuery Mobile Development" />
            <KEYBlue text="jQuery Plugin Development" />
            </div>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-6">
            <div className="gap-5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
            <KEYBlue text="jQuery Theme/Template Development" />
            <KEYBlue text="jQuery Animation Creation" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default JquerywebServices
